import { requestApi } from '~/services/api.js';

const LS_BASE_URL = '/locationsmart/public';

export const isComplianceExpired = ({ sessionId }) => {
	return requestApi(`${LS_BASE_URL}/isComplianceExpired?sessionId=${sessionId}`);
};

export const getComplianceResult = ({ html5SessionId, profileSessionId, ipAddress }) => {
	const payload = {
		html5SessionId,
		dProfileSessionId: profileSessionId,
		ipAddress
	};

	return requestApi(`${LS_BASE_URL}/getComplianceResult`, payload, 'POST');
};

export const updateDeniedStatus = payload => {
	return requestApi(`${LS_BASE_URL}/addLocationSharingDenied`, payload, 'POST');
};
